import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import { getPeriodTextByDay } from 'utils';

import { TooltipWrapper } from './components/TooltipWrapper';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

type PeriodProps = {
  periodDays: string;
  toolTip?: string;
};

export const Period: FC<PeriodProps> = ({ periodDays, toolTip }) => {
  const subscriberPaymentPeriodText = getPeriodTextByDay(periodDays);

  return (
    <div className={cn('component', 'mar-l-3xs')}>
      <Text size="size5-r-l">{`/ ${subscriberPaymentPeriodText}`}</Text>
      {toolTip && (
        <div className={cn('tooltip', 'mar-r-3xs')}>
          <TooltipWrapper message={toolTip} />
        </div>
      )}
    </div>
  );
};
